import { ILevel, ILevelRange } from 'src/features/devHub/interfaces/devhub';
import { EItemRarity } from 'src/styles/theme/utils/enums';

// konami code
function konamiCode(callback: () => void): void {
	// detect konami code
	const _konamiCode = 'UpUpDownDownLeftRightLeftRightBA';
	let konamiCodePosition = 0;

	document.addEventListener('keydown', (e) => {
		const key = `${e.key}`;

		if (key === _konamiCode[konamiCodePosition]) {
			konamiCodePosition++;

			if (konamiCodePosition === _konamiCode.length) {
				callback();
				konamiCodePosition = 0;
			}
		} else {
			konamiCodePosition = 0;
		}
	});
}

// calculate rarity for experience points
function calculateRarity(value?: number, isGold: boolean | undefined = false): EItemRarity {
	if (!value) {
		return EItemRarity.common;
	}

	const goldThresholds = [20, 30, 50, 150];
	const regularThresholds = [400, 800, 1500, 3500];
	const thresholds = isGold ? goldThresholds : regularThresholds;

	switch (true) {
		case value < thresholds[0]:
			return EItemRarity.common;
		case value < thresholds[1]:
			return EItemRarity.uncommon;
		case value < thresholds[2]:
			return EItemRarity.rare;
		case value < thresholds[3]:
			return EItemRarity.epic;
		default:
			return EItemRarity.legendary;
	}
}

function getExperienceRange(level?: number): ILevelRange {
	if (typeof level === 'undefined') {
		return {
			min: 0,
			max: 0
		};
	}

	const min = 0;
	const max = min + 1000;

	return {
		min,
		max
	};
}

// calculate the level knowing the range and the experience points
function calculateSkillLevel(experience?: number): ILevel {
	if (!experience) {
		return { level: 0, levelExpPoints: 0 };
	}

	const level = Math.floor(experience / 1000);
	const levelExpPoints = experience % 1000;

	return { level, levelExpPoints };
}

function calculateUserLevel(experience?: number): ILevel {
	if (typeof experience === 'undefined') {
		return { level: 0, levelExpPoints: 0 };
	}

	const level = 1 + Math.floor(1.5 * Math.pow(experience / 2500, 0.6));

	return { level, levelExpPoints: 0 };
}

export { konamiCode, calculateRarity, getExperienceRange, calculateSkillLevel, calculateUserLevel };
